import { Box, Flex, Text, useDisclosure, chakra, Icon, Button } from '@chakra-ui/react';
import { Trans } from '@lingui/macro';
import { motion } from 'framer-motion';

import { BTN_ICON_BOXSIZE } from '../../utils/styleUtil';

const MotionBox = chakra(motion.div);

export default function BottomOnglet({ children, title, titleIcon, brandColor, openByDefault = false, collapsedHeight, expandedHeight }) {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: openByDefault });

  const contentHeight = `calc(${expandedHeight}px - ${collapsedHeight}px)`;

  return (
    <MotionBox
      position="fixed"
      bottom="0"
      left={{ base: '0', sm: '50%' }}
      right={{ base: '0', sm: 'unset' }}
      transform={{ base: undefined, sm: 'translateX(-50%)' }}
      minW="320px"
      zIndex="modal"
      bg="brand.background_container"
      borderTopRadius="2xl"
      boxShadow="dark-lg"
      initial={openByDefault}
      animate={{ height: isOpen ? expandedHeight : collapsedHeight }}
      transition={{ type: 'spring', stiffness: 260, damping: 28 }}
    >
      <Flex h={`${collapsedHeight}px`} px="4" align="center" justify="space-between" onClick={onToggle} cursor="pointer">
        <Flex align="center" gap="3">
          {titleIcon && <Icon as={titleIcon} boxSize={BTN_ICON_BOXSIZE} color={brandColor} />}
          <Text fontWeight="semibold">{title}</Text>
        </Flex>
        <Button ml="20px" size="sm" variant="outline" flexShrink="0">
          {!isOpen && <Trans>View</Trans>}
          {isOpen && <Trans>Close</Trans>}
        </Button>
      </Flex>

      {isOpen && (
        <Box h={contentHeight} overflowY="auto" px="4">
          {children}
        </Box>
      )}
    </MotionBox>
  );
}
